import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { useSeason } from '../../context/SeasonContext';

const Crumb = ({ to, children }) => (
    <Box component={RouterLink} to={to} sx={{ color: 'primary.main', textDecoration: 'none' }}>
        {children}
    </Box>
);

/**
 * Kruimelpad binnen een seizoen: Seizoenen › <seizoen> › <pagina>.
 *
 * Met `trail` hangen er tussenstappen tussen, voor pagina's die dieper liggen —
 * de kalender gaat van ronde naar wedstrijd en dat pad moet terug te lopen zijn.
 */
function SeasonBreadcrumb({ page, trail = [] }) {
    const { season, seasonId } = useSeason();

    return (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            <Crumb to="/admin">Seizoenen</Crumb>
            {' › '}
            <Crumb to={`/admin/season/${seasonId}/dashboard`}>
                {season?.displayName || season?.name}
            </Crumb>
            {trail.map((step) => (
                <React.Fragment key={step.to}>
                    {' › '}
                    <Crumb to={step.to}>{step.label}</Crumb>
                </React.Fragment>
            ))}
            {page ? ` › ${page}` : ''}
        </Typography>
    );
}

export default SeasonBreadcrumb;
